import Gallery from "../component/Gallery";

export default function Bbva() {
  let $elemfarmers = document.querySelector(
    ".view-block-farmers .view-content"
  );
  Gallery($elemfarmers);
}